import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  CalendarMaxDate,
  FiltersState,
  IRangeDateInfo,
  PeriodType,
  RangePickerType,
  SetFilters
} from '@lla-platform/core/core-data-access'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Store } from '@ngxs/store'

@UntilDestroy()
@Component({
  selector: 'lla-range-date-picker-dialog',
  templateUrl: './range-date-picker-dialog.component.html',
  styleUrls: ['./range-date-picker-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RangeDatePickerDialogComponent implements OnInit {
  rangePickerType: RangePickerType

  constructor(
    public dialogRef: MatDialogRef<RangeDatePickerDialogComponent>,
    private store: Store,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedValue: IRangeDateInfo
      maxDate: CalendarMaxDate
      minDate: string
      hideAllPeriods: boolean
      hiddenPeriods: PeriodType[]
      showMoonLanding: boolean
      enableRangePickerType: boolean
    }
  ) {}

  ngOnInit(): void {
    const rangePickerTypeFilter = this.store.selectSnapshot(FiltersState.rangePickerType)
    this.rangePickerType =
      this.data.enableRangePickerType && rangePickerTypeFilter ? rangePickerTypeFilter : 'daily'
  }

  saveRangePickerType(rangePickerType: RangePickerType) {
    if (this.data.enableRangePickerType) {
      this.store.dispatch(new SetFilters({ rangePickerType }))
    }
  }
}
